/**
 * Component: Country Modal
 * -----------------------------------------------------------------------------
 * - Displays a modal window with a country picker form.
 *
 * @namespace CountryModal
 */
import cssClasses from '~/helpers/classes'

/**
 * DOM selectors.
 */
const selectors = {
  openModal: '[js-country-modal="openModalButton"]',
  closeModal: '[js-country-modal="closeModalButton"]',
  countryModal: '.country-modal',
  countryModalContent: '.country-modal__inner',
}

export default () => {

  /**
   * DOM Node elements.
   */
  const nodeElements = {
    countryModal: document.querySelector(selectors.countryModal),
  }

  /**
   * Initialise component.
   */
  function init() {
    setEventListeners()
  }

  /**
   * Set Event listeners.
   *
   * @description Adds event listeners to open and close the `countryModal`.
   */
  function setEventListeners() {
    document.body.addEventListener('click', (_event) => {
      const openPopupTarget = _event.target.closest(selectors.openModal)
      const closePopupTarget = _event.target.closest(selectors.closeModal)
      const countryModalContentTarget = _event.target.closest(
        selectors.countryModalContent,
      )

      const isOpened = Boolean(
        nodeElements.countryModal?.classList.contains(cssClasses.active),
      )

      if (openPopupTarget && !isOpened) {
        openModal()
        return
      }

      /**
       * Close the modal when clicking on the close button or outside the modal.
       */
      if (
        isOpened &&
        (closePopupTarget || (!closePopupTarget && !countryModalContentTarget))
      ) {
        closeModal()
        return
      }
    })
  }

  /**
   * Open the modal.
   *
   * @description Adds the `is-active` class to display the modal, locks body
   * scroll.
   */
  function openModal() {
    nodeElements.countryModal?.classList.add(cssClasses.active)
    document.body.classList.add(cssClasses.locked)
  }

  /**
   * Close the modal.
   *
   * @description Removes `is-active` class to hide the modal, unlocks body
   * scroll.
   */
  function closeModal() {
    nodeElements.countryModal?.classList.remove(cssClasses.active)
    document.body.classList.remove(cssClasses.locked)
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  })
}
